
import { defineComponent } from "vue";
import { useTypedStore } from "@/store";

// Taken from here (https://github.com/nicolasbeauvais/vue-social-sharing/tree/master/src) because it doesn't work with Vue3.

export default defineComponent({
  name: "Share",
  setup() {
    const { getters } = useTypedStore();
    const $window = typeof window !== "undefined" ? window : null;

    const popup = {
      width: 626,
      height: 436,
      top: 0,
      left: 0,
      window: undefined as any,
      interval: undefined,
    };

    const resizePopup = () => {
      if ($window) {
        const width =
          $window.innerWidth ||
          document.documentElement.clientWidth ||
          $window.screenX;
        const height =
          $window.innerHeight ||
          document.documentElement.clientHeight ||
          $window.screenY;
        const systemZoom = width / $window.screen.availWidth;

        popup.left =
          (width - popup.width) / 2 / systemZoom +
          ($window.screenLeft !== undefined
            ? $window.screenLeft
            : $window.screenX);
        popup.top =
          (height - popup.height) / 2 / systemZoom +
          ($window.screenTop !== undefined
            ? $window.screenTop
            : $window.screenY);
      }
    };

    const share = () => {
      resizePopup();

      // If a popup window already exist, we close it and trigger a change event.
      if (popup.window && popup.interval) {
        clearInterval(popup.interval);

        // Force close (for Facebook)
        window.close();
      }

      popup.window = $window?.open(
        getLink(),
        "sharer",
        ",height=" +
          popup.height +
          ",width=" +
          popup.width +
          ",left=" +
          popup.left +
          ",top=" +
          popup.top +
          ",screenX=" +
          popup.left +
          ",screenY=" +
          popup.top
      );

      popup.window.focus();
    };

    const getLink = () => {
      const link =
        "https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d&quote=@q&hashtag=@h";

      const data = {
        url: "mytopiagame.co.uk",
        title: "Mytopia | The green city builder game",
        description:
          "MyTopia is a multiple choice, city building simulation game commissioned as part of the second annual Waterline Summit and being developed by local companies Edenic Group and Clay10, in collaboration with Marketing Humber",
        quote: `I built my green city in Mytopia and scored ${getters.score}. Click the link to build your green city.`,
      };

      return (
        link
          // .replace(/@tu/g, "&via=" + encodeURIComponent(data.twitterUser))
          .replace(/@u/g, encodeURIComponent(data.url))
          .replace(/@t/g, encodeURIComponent(data.title))
          .replace(/@d/g, encodeURIComponent(data.description))
          .replace(/@q/g, encodeURIComponent(data.quote))
        // .replace(/@h/g, data.encodedHashtags)
        // .replace(/@m/g, encodeURIComponent(data.media));
      );
    };

    return {
      share,
    };
  },
});
